/**
 * learning/staleness.ts — how old the cached Microsoft Learn feed may be before the page says so
 * (LH-F04), and the one date format used when it does.
 *
 * Extracted from LearningHub.tsx so the Kombi Learning page states staleness in exactly the same
 * words from exactly the same threshold. Two copies of "is this out of date" is two different answers
 * to the same question.
 */

/** How old the cached Learn feed may be before the page says so (LH-F04). */
export const STALE_AFTER_DAYS = 1;

export function isStale(iso: string | null): boolean {
  if (!iso) return false;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return false;
  const ageDays = (Date.now() - t) / (1000 * 60 * 60 * 24);
  return ageDays > STALE_AFTER_DAYS;
}

export function shortDate(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString();
}
